import { useDispatch } from 'react-redux'
import { promisifyAction } from './reduxPromiseHelpers'

export default () => {
  const dispatch = useDispatch()
  return (action) => promisifyAction(dispatch)(action).promise
}
